query getQuizPreConversion($preConversionId: ID!) {
  quizPreConversion: getQuizPreConversion(preConversionId: $preConversionId) {
    id
    landingpage {
      id
      name
    }
    type
    details {
      result
      answers {
        question
        answer
        screenId
      }
    }
  }
}
